module.exports = __webpack_public_path__ + "img/industrial_plan.2fcb3c69.png";